import api from './api'

export const submitContactEmail = async (event, subject = 'Website inquiry') => {
  event.preventDefault()
  const form = event.currentTarget
  const formData = new FormData(form)
  const payload = Object.fromEntries(formData.entries())

  const { data } = await api.post('/contact', { ...payload, subject })
  form.reset()

  return data
}
